var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row roomy align-center align-stretch" },
    [
      _vm._l(_vm.iconPacks, function (pack) {
        return _c(
          "div",
          {
            key: pack.name,
            staticClass:
              "all-icon-packs-listing column-12 tablet:column-6 laptop:column-4",
            staticStyle: {
              "--card-min-height": "var(--icon-pack-card-min-height, 12rem)",
            },
          },
          [
            _c(
              "site-link",
              {
                class: `card header icon-pack-card icon-pack-card-${pack.name}`,
                style: `
          background-clip: padding-box;
          background-image: url('/images/icons/packs/${pack.name}/${pack.thumbImage}');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        `,
                attrs: { to: _vm.$pack({ name: pack.name }) },
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(pack.label)),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.moreSoon
        ? _c("div", { staticClass: "column" }, [
            _c(
              "div",
              {
                staticClass:
                  "card secondary with-border padding-xl muted align-center display-flex flex-column align-middle",
                staticStyle: { "--border-style": "dashed", height: "100%" },
              },
              [
                _c("wa-question-mark-block", {
                  attrs: {
                    "block-hover-primary-color": "var(--fa-navy)",
                    "block-size": "2x",
                  },
                }),
                _vm._v(" "),
                _c("p", { staticClass: "margin-top-2xs tablet:size-sm" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.ProPlusExclusiveIconPacksCount) +
                      " new Pro+ icon packs are available now, with new icon packs dropping regularly!\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "tag teal" }, [
                  _vm._v("More Icon Packs Coming Soon!"),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }